import UploadPhoto from './UploadPhoto.vue';

export default UploadPhoto;



// WEBPACK FOOTER //
// ./src/FcComponents/uploadPhoto/index.js